<template>
    <fieldset>
      <legend class="panel-title"><b-link v-b-toggle.collapse-3 role="button" >Job Type</b-link></legend>

      <!-- <legend class="panel-title"><a data-toggle="collapse" href="#collapse3" role="button" aria-expanded="false" aria-controls="collapse3" class="collapsed">Job Type</a> </legend> -->
      <b-collapse id="collapse-3">
        <div v-for="(value, key) in processedCommitment" class="input-list" :key="key">
        <label><input type="checkbox" v-bind:id="key" v-bind:value="key"  v-model="checkedNames" v-on:change="getCheckboxeIds()" /> {{ key }} ({{ value }})</label>
        </div>
      </b-collapse>
    </fieldset>
</template>

<script>
import { EventBus } from '../event-bus.js';

export default {
  name: 'CommitmentBox',
  props: ['commitmentData'],
  data: function () {
    return {
      checkedNames: [],
      taxonomyTags: {}
    }
  },
  computed: {
    processedCommitment() {
      // console.log(this.commitmentData);
      return this.commitmentData;
    }
  },
  methods: {
     getCheckboxeIds() {
    //   checkedCommitmentIDstore = this.checkedNames;
      EventBus.$emit('checkedCommitmentIDstore', this.checkedNames);

    //   this.$parent.getFilteredJobs(checkedLocationIDstore, checkedTeamIDstore, checkedCommitmentIDstore);
      // console.log(this.checkedNames);
     },
     uncheckBoxes(){
      //console.log("child");
      this.checkedNames=[];
      EventBus.$emit('checkedCommitmentIDstore', this.checkedNames);
     },
     uncheckBox(box){
      var index = this.checkedNames.indexOf(box);
      if (index > -1) {
        this.checkedNames.splice(index, 1);
      }
      EventBus.$emit('checkedCommitmentIDstore', this.checkedNames);

      // console.log(checkedLocationIDstore);
    //   this.$parent.getFilteredJobs();
     }
  }
}
</script>
